import React, { useState, useEffect } from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import {
  FaHome,
  FaFileAlt,
  FaLayerGroup,
  FaShieldAlt,
  FaPuzzlePiece,
  FaStickyNote,
  FaSync,
  FaFolderOpen,
  FaCertificate,
  FaTimesCircle,
  FaHandsHelping,
  FaChartBar,
  FaWallet,
  FaChevronDown,
  FaTimes,
  FaExclamationCircle,
  FaFileInvoice,
} from 'react-icons/fa';
import './Sidebar.css';

const menuItems = [
  { label: 'Dashboard', icon: <FaHome />, path: '/dashboard' },
  { label: 'Get Cover', icon: <FaFileAlt />, path: '/get-cover' },
  { label: 'Bulk Processing', icon: <FaLayerGroup />, path: '/bulk-processing' },
  { label: 'Active Policies', icon: <FaShieldAlt />, path: '/active-policies' },
//   { label: 'Pending Proposals', icon: <FaFileInvoice />, path: '/pending-proposals' },
  { label: 'Extensions', icon: <FaPuzzlePiece />, path: '/extensions' },
  { label: 'Notes', icon: <FaStickyNote />, path: '/notes' },
  {
    label: 'Renewals Management',
    icon: <FaSync />,
    path: '/renewals',
    children: [
      { label: 'Due Renewals', path: '/renewals/due' },
      { label: 'Expired', path: '/renewals/expired' },
    ],
  },
  { label: 'Documents', icon: <FaFolderOpen />, path: '/documents' },
  { label: 'Generated Certificates', icon: <FaCertificate />, path: '/generated-certificates' },
  { label: 'Failed Certificates', icon: <FaTimesCircle />, path: '/failed-certificates' },
  { label: 'Claims', icon: <FaHandsHelping />, path: '/claims' },
  {
    label: 'Reports',
    icon: <FaChartBar />,
    path: '/reports',
    children: [
      { label: 'Production Report', path: '/reports/production' },
      { label: 'Commission Report', path: '/reports/commission' },
    ],
  },
  { label: 'Wallet', icon: <FaWallet />, path: '/wallet' },
  { label: 'Double Insurance', icon: <FaExclamationCircle />, path: '/double-insurance' },
];

const Sidebar = () => {
  const location = useLocation();
  const [openMenus, setOpenMenus] = useState({});

  const toggleSubMenu = (label) => {
    setOpenMenus((prev) => ({ ...prev, [label]: !prev[label] }));
  };

  const closeSidebar = () => {
    document.body.classList.remove('sidebar-open');
  };

  // Close sidebar on route change (mobile)
  useEffect(() => {
    closeSidebar();
  }, [location.pathname]);

  return (
    <>
      {/* Overlay (mobile only) */}
      <div className="sidebar-overlay" onClick={closeSidebar} />

      <aside className="sidebar">
        {/* Mobile close button */}
        <button className="sidebar-close-btn" onClick={closeSidebar} aria-label="Close menu">
          <FaTimes />
        </button>

        <span className="sidebar-label">Menu</span>
        <ul className="sidebar-nav">
          {menuItems.map((item) => (
            <li key={item.label} className="sidebar-item">
              {item.children ? (
                <>
                  <button
                    className={`sidebar-link ${location.pathname.startsWith(item.path) ? 'active' : ''}`}
                    onClick={() => toggleSubMenu(item.label)}
                  >
                    <span className="sidebar-link-icon">{item.icon}</span>
                    <span className="sidebar-link-text">{item.label}</span>
                    <FaChevronDown className={`sidebar-chevron ${openMenus[item.label] ? 'open' : ''}`} />
                  </button>
                  <ul className={`sidebar-submenu ${openMenus[item.label] ? 'open' : ''}`}>
                    {item.children.map((child) => (
                      <li key={child.path}>
                        <NavLink
                          to={child.path}
                          className={({ isActive }) => `sidebar-link ${isActive ? 'active' : ''}`}
                        >
                          <span className="sidebar-link-text">{child.label}</span>
                        </NavLink>
                      </li>
                    ))}
                  </ul>
                </>
              ) : (
                <NavLink
                  to={item.path}
                  className={({ isActive }) => `sidebar-link ${isActive ? 'active' : ''}`}
                >
                  <span className="sidebar-link-icon">{item.icon}</span>
                  <span className="sidebar-link-text">{item.label}</span>
                </NavLink>
              )}
            </li>
          ))}
        </ul>
      </aside>
    </>
  );
};

export default Sidebar;
